export const sidebarIcons = "24px";
export const expandedWidth = 252;
export const collapsedWidth = 76;
